module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visibleEdit) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visibleEdit),
      callback: function($$v) {
        _vm.visibleEdit = $$v
      },
      expression: "visibleEdit"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0 rounded-xl"
  }, [_c('v-card-title', [(_vm.$vars.beta) ? _c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "label": "",
      "dark": "",
      "small": ""
    }
  }, [_vm._v("Chargenansicht")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.localBbr.titel) + " " + _vm._s(_vm.localBbr.vorname) + " " + _vm._s(_vm.localBbr.nachname) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": "",
      "center-active": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', [_vm._v(" Allgemein ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Rechnungen ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Nachrichten ")]), _vm._v(" "), _c('v-tab', [_vm._v(" Änderungen ")]), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tab', [_vm._v(" Debug Data ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-tabs-items', {
    attrs: {
      "slider-color": "red"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 0) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "offset": "3",
      "order-xs": "5",
      "sm": "4",
      "offset-sm": "4",
      "md": "2",
      "offset-md": "0"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "ma-4",
    attrs: {
      "src": _vm.localBbr.bildAhnengalerie200
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        (_vm.showPicture = true) &&
        (_vm.uploadStatus = {
          img_upload: null,
          img_url1: null,
          img_url2: null,
          img_url3: null
        }) &&
        (_vm.message = undefined)
      }
    }
  }, [_vm._v("Bild bearbeiten")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "pa-2 mt-2 text-center",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-center"
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "size": "36",
      "indeterminate": "",
      "color": "primary"
    }
  }) : _c('span', [(_vm.checkMailValue.status) ? _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.changeLoginAllow
    }
  }, [_c('v-icon', [_vm._v("check_box")])], 1) : _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.changeLoginAllow
    }
  }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.checkMailValue.status) ? _c('span', [_vm._v("Der Kontakt darf sich für die App registrieren und einloggen.")]) : _c('span', [_vm._v("Registrieren und Einloggen unterbunden.")])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "text-center caption pt-4",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                  Zuletzt geändert:\n                  "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("event")]), _vm._v(_vm._s(_vm.$filters.date(_vm.localBbr.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("person")]), _vm._v(_vm._s(_vm.$filters.user(_vm.localBbr.zuletztGeaendertVon, _vm.bbrbbr2)))], 1), _vm._v(" "), (_vm.localBbr.anmeldeID) ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "label": ""
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("check")]), _vm._v("Account bei Korpodesk")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "0",
      "lg": "5",
      "offset-lg": "0"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Kontaktdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.felder.neuFelder), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "2",
      "lg": "5",
      "offset-lg": "0"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Finanzdaten")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2"
  }, [(_vm.felder.finanzFelder.showSepaMandat) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [(_vm.localBbr.sepaLastschriftmandat) ? _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]) : _c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" SEPA-Lastschriftmandat ")]), _vm._v(" "), (_vm.localBbr.sepaLastschriftmandat) ? _c('v-card-subtitle', [_vm._v("\n                              " + _vm._s(_vm.$filters.date(_vm.localBbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY")) + " Uhr\n                            ")]) : _c('v-card-subtitle', [_vm._v("\n                              Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.\n                            ")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.localBbr.sepaLastschriftmandat) ? _c('span', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadLastschrift(_vm.localBbr.sepaLastschriftmandat)
      }
    }
  }, [_c('v-icon', [_vm._v("download")])], 1)], 1) : _c('span', [_c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingLaschriftmandatHochladen
    },
    on: {
      "click": function($event) {
        return _vm.clickHochladenLastschriftmandat()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cloud_upload")]), _vm._v("Hochladen\n                            ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "pdf/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1), _vm._v(" "), (_vm.loadingLaschriftmandatHochladen) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.felder.finanzFelder.beitrage), function(item, index) {
    return _c('uiKontaktField', {
      key: index,
      attrs: {
        "feld": item,
        "value": _vm.bbr[item.value]
      },
      on: {
        "dataChange": function($event) {
          return _vm.saveData.apply(void 0, arguments)
        }
      }
    })
  }), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "loading": _vm.loading_checkIban,
      "label": "IBAN"
    },
    on: {
      "change": function($event) {
        return _vm.checkIban()
      }
    },
    model: {
      value: (_vm.localBbr.iban),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "iban", $$v)
      },
      expression: "localBbr.iban"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": "",
      "label": "BIC",
      "placeholder": "Automatisch berechnet"
    },
    model: {
      value: (_vm.localBbr.bic),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "bic", $$v)
      },
      expression: "localBbr.bic"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Kontoinhaber",
      "append-icon": _vm.localBbr.kontoinhaber ? '' : 'refresh',
      "rules": [_vm.rules.required]
    },
    on: {
      "click:append": function($event) {
        _vm.localBbr.kontoinhaber = _vm.localBbr.vorname + ' ' + _vm.localBbr.nachname
      }
    },
    model: {
      value: (_vm.localBbr.kontoinhaber),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "kontoinhaber", $$v)
      },
      expression: "localBbr.kontoinhaber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": "Mandatsreferenz",
      "append-icon": _vm.localBbr.mandatsreferenz ? '' : 'refresh'
    },
    on: {
      "click:append": function($event) {
        return _vm.calcMandatsreferenz()
      }
    },
    model: {
      value: (_vm.localBbr.mandatsreferenz),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "mandatsreferenz", $$v)
      },
      expression: "localBbr.mandatsreferenz"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.felder.finanzFelder.showBankdaten) ? _c('uiKontaktField', {
    attrs: {
      "feld": {
        breite: 6,
        label: 'Mandat Unterschriftsdatum',
        type: 'Date',
        value: 'mandatUnterschriftsdatum',
      },
      "value": _vm.bbr.mandatUnterschriftsdatum
    },
    on: {
      "dataChange": function($event) {
        return _vm.saveData.apply(void 0, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fehlerSepa.sepa) ? _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.fehlerSepa.sepa))])], 1) : _vm._e()], 2), _vm._v(" "), (_vm.felder.finanzFelder.showSepaMandat) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("SEPA-Einstellungen")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "py-1"
  }, [_vm._v("Welche Kassen dürfen per SEPA Rechnungen einziehen?")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.disableSEPA) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "d-flex justify-start align-center pr-2"
  }, [_c('span', {
    staticClass: "pa-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "red"
    }
  }, [_vm._v("warning_amber")])], 1), _vm._v(" "), _c('span', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Kontodaten fehlen! ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                                Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die\n                                Kontodaten eingetragen werden.\n                              ")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.kassen), function(item, index) {
    return (item.name) ? _c('v-col', {
      key: index,
      staticClass: "py-1 px-1",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-checkbox', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": _vm.disableSEPA,
        "on-icon": "check_box",
        "off-icon": "check_box_outline_blank",
        "label": item.name
      },
      model: {
        value: (_vm.sepa[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.sepa, item.name, $$v)
        },
        expression: "sepa[item.name]"
      }
    })], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.$vars.verbindung === 'rbo') ? _c('span', [(_vm.localBbr.versand) ? _c('span', [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Versand-Einstellungen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Semesterprogramm"
    },
    model: {
      value: (_vm.localBbr.versand['semesterprogramm']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'semesterprogramm', $$v)
      },
      expression: "localBbr.versand['semesterprogramm']"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Einladungen"
    },
    model: {
      value: (_vm.localBbr.versand['einladungen']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'einladungen', $$v)
      },
      expression: "localBbr.versand['einladungen']"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Ripuarenblätter"
    },
    model: {
      value: (_vm.localBbr.versand['ripuarenblätter']),
      callback: function($$v) {
        _vm.$set(_vm.localBbr.versand, 'ripuarenblätter', $$v)
      },
      expression: "localBbr.versand['ripuarenblätter']"
    }
  })], 1)], 1)], 1) : _c('span', [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localBbr.versand = {}
      }
    }
  }, [_vm._v("Versand-Einstellungen hinzufügen")])], 1)], 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "2",
      "lg": "10",
      "offset-lg": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "hint": "Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben.",
      "rows": "5",
      "auto-grow": "",
      "label": "Bemerkungen"
    },
    model: {
      value: (_vm.localBbr.bemerkungen),
      callback: function($$v) {
        _vm.$set(_vm.localBbr, "bemerkungen", $$v)
      },
      expression: "localBbr.bemerkungen"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    staticClass: "pa-4",
    attrs: {
      "min-height": "calc(90vh - 166px)",
      "color": "grey lighten-4"
    }
  }, [_c('Rechnungen', {
    attrs: {
      "kontakt": _vm.localBbr.id
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 2) ? _c('v-simple-table', {
    staticClass: "hidden-xs-only",
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Absender")]), _vm._v(" "), _c('th', [_vm._v("Betreff")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "pa-0"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nachrichten), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.absender.name)), _c('br'), _vm._v(_vm._s(item.absender.position))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.message.subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', {
      staticClass: "pa-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nachrichten), function(item) {
    return _c('v-card', {
      key: item.name,
      staticClass: "ma-2 hidden-sm-and-up",
      attrs: {
        "outlined": ""
      },
      on: {
        "dblclick": function($event) {
          (_vm.selectNachricht = item) && (_vm.showBbrNachricht = true)
        }
      }
    }, [_c('v-list-item', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "text-caption"
    }, [_vm._v("\n                    " + _vm._s(item.absender.name) + " " + _vm._s(item.absender.position) + " |\n                    " + _vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY hh:mm")) + " Uhr\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle-2"
    }, [_vm._v("\n                    " + _vm._s(item.message.subject) + "\n                  ")])], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 3) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Geändert von")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th', [_vm._v("Geänderte Felder")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bearbeitungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.dataNeu.zuletztGeaendertVon, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', _vm._l((item.anders), function(item2, index2) {
      return _c('v-tooltip', {
        key: item2,
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-chip', _vm._g({
              attrs: {
                "small": ""
              }
            }, on), [_vm._v(_vm._s(item2))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-simple-table', {
        staticClass: "transparent",
        attrs: {
          "dense": "",
          "dark": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("von")]), _vm._v(" "), _c('th', [_vm._v("zu")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(item.dataAlt[item2] ? item.dataAlt[item2] : "-"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dataNeu[item2] ? item.dataNeu[item2] : "-"))])])])])], 1)
    }), 1)])
  }), 0)]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tab-item', [_c('v-sheet', {
    attrs: {
      "min-height": "calc(90vh - 166px)"
    }
  }, [(_vm.active === 4) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 166px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.localBbr), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteKontakt = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v("\n      " + _vm._s(_vm.localBbr.delete) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveBbr()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPicture),
      callback: function($$v) {
        _vm.showPicture = $$v
      },
      expression: "showPicture"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Neues Bild hochladen - " + _vm._s(_vm.localBbr.titel) + " " + _vm._s(_vm.localBbr.vorname) + " " + _vm._s(_vm.localBbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-file-input', {
    attrs: {
      "loading": _vm.selectPicture !== '' && (!_vm.message || !_vm.error),
      "outlined": "",
      "dense": "",
      "prepend-icon": "attach_file",
      "label": "Neues Bild"
    },
    on: {
      "change": _vm.previewImage
    },
    model: {
      value: (_vm.selectPicture),
      callback: function($$v) {
        _vm.selectPicture = $$v
      },
      expression: "selectPicture"
    }
  }), _vm._v(" "), (_vm.uploadStatus.img_upload !== null) ? _c('span', [_c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadValue === 100 ? 'green' : 'blue',
      "value": _vm.uploadValue,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Upload (" + _vm._s(_vm.uploadValue.toFixed(0)) + " %)")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url1 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url1 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url1 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 1 berechnen")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url2 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url2 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url2 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 2 berechnen")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.uploadStatus.img_url3 ? 'green' : 'blue',
      "value": _vm.uploadStatus.img_url3 ? 100 : 0,
      "indeterminate": _vm.uploadStatus.img_url3 === false,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("Bild 3 berechnen")])], 1) : _vm._e(), _vm._v("\n        Neben dem Originalbild werden noch 3 weitere Versionen gespeichert. Falls ein Fehler auftritt lad die Seite\n        bitte neu und versuch das Bild erneut hochzuladen.\n\n        "), (_vm.message) ? _c('v-alert', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.uploadStatus.error) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          Es ist ein Fehler aufgetreten. Bitte lade die Seite neu.\n          "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.uploadStatus.error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.selectPicture !== '' && !(!_vm.message || !_vm.error),
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicture = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteKontakt,
      "title": "Kontakt löschen",
      "message": "Willst du diesen Kontakt wirklich löschen? Der Kontakt wird dabei als gelöscht markiert und erscheint in keinen weiteren Auflistungen. Er kann aber zu einem späteren Zeitpunkt wieder hergestellt werden. Eine endgültige Löschung ist nicht möglich.",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteKontakt = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteKontakt()
      },
      "closeFalse": function($event) {
        _vm.showDeleteKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showBbrRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbrRechnung = $event
      },
      "close": function($event) {
        _vm.showBbrRechnung = false
      }
    }
  }), _vm._v(" "), (_vm.selectNachricht) ? _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showBbrNachricht),
      callback: function($$v) {
        _vm.showBbrNachricht = $$v
      },
      expression: "showBbrNachricht"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.selectNachricht.message.subject) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrNachricht = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.selectNachricht.datum, "DD.MM.YYYY")) + " von " + _vm._s(_vm.selectNachricht.absender.name) + "\n      ")]), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-4 emailFeld",
    domProps: {
      "innerHTML": _vm._s(_vm.selectNachricht.message.html)
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrNachricht = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28701196"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogKontaktEdit.vue
// module id = 745
// module chunks = 15